<template>
    <div class="device-info-card">
        <div class="info-item">
            <span class="label">上次登录时间: </span>
            <span class="value nowrap">{{ time }}</span>
        </div>

        <div class="info-item">
            <span class="label">设备 ID: </span>
            <span class="value nowrap">{{ id }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: 'DeviceInfoCard',
    props: {
        time: {
            type: String,
            required: true
        },
        id: {
            type: String,
            required: true
        },
    },
}
</script>

<style scoped>
.device-info-card {
    width: 260px;
    border: 1px solid #ccc;
    border-radius: 10px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    flex-direction: column;
    justify-content: top;
    align-items: center;
    padding: 30px;
        gap: 10px;
    background-color: #f9f9f9;
}

.device-info-card .spacer {
    height: 20px;
}
.info-item {
    line-height: 1.5;
}

.label {
    font-weight: bold;
    margin-right: 5px;
}

.value {
    color: #333;
}
.nowrap {
    white-space: nowrap;
}
</style>